<div class="modal-overlay" *ngIf="open" (click)="dismissible && close()">
  <div class="modal-container" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <span class="modal-title">
        {{ 'pages.planDetails.ChangePlanModal.title' | i18n }}
      </span>
      <i *ngIf="dismissible" class="bi bi-x-circle close-icon" (click)="close()" aria-hidden="true"></i>
    </div>

    <div class="modal-body">
      <div *ngIf="currentStep === 'choice'">
        <div class="option-grid">
          <div
            *ngIf="canChangeQuantity"
            class="option-card"
            (click)="selectQuantity()"
          >
            <strong>{{ 'pages.planDetails.ChangePlanModal.changeQuantity' | i18n }}</strong>
            <p>{{ 'pages.planDetails.ChangePlanModal.updateLicenses' | i18n }}</p>
          </div>

          <div
            *ngIf="canChangePlan"
            class="option-card"
            (click)="selectPlanStep()"
          >
            <strong>{{ 'pages.planDetails.ChangePlanModal.switchPlan' | i18n }}</strong>
            <p>{{ 'pages.planDetails.ChangePlanModal.switchPlan' | i18n }}</p>
          </div>

        </div>

        <div class="modal-footer">
          <button
            *ngIf="dismissible"
            type="button"
            class="btn btn-secondary"
            (click)="close()"
          >
            {{ 'pages.planDetails.ChangePlanModal.cancelChange' | i18n }}
          </button>
        </div>
      </div>

      <div *ngIf="currentStep === 'quantity'" class="quantity">
        <p class="modal-section-title">
          {{ 'pages.planDetails.ChangePlanModal.selectQuantityTitle' | i18n }}
        </p>

        <umkt-cart-product-item
          *ngIf="mappedProduct"
          [product]="mappedProduct"
          [isChangePlan]="true"
          [changePlanLicenseCap]="initialQuantity"
          (changeQty)="onChangeQty($event)"
        >
        </umkt-cart-product-item>

        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="back()">
            {{ 'pages.planDetails.ChangePlanModal.back' | i18n }}
          </button>
          <button
            class="btn btn-primary"
            type="button"
            [disabled]="quantity >= initialQuantity"
            (click)="confirmQuantity()"
          >
            {{ 'pages.planDetails.ChangePlanModal.confirm' | i18n }}
          </button>
        </div>
      </div>

      <div *ngIf="currentStep === 'plan'" class="change-plan">
        <p class="modal-section-title">
          {{ 'pages.planDetails.ChangePlanModal.choosePlan' | i18n }}
        </p>

        <div *ngIf="loadingProduct">
          <umkt-loading 
            [isLoading]="true"
            [size]="'md'"
            [mode]="'contained'">
          </umkt-loading>
        </div>

        <div *ngIf="!loadingProduct && product">
          <umkt-expansable-card
            [plans]="product.variations"
            [productUuid]="product.uuid || productUuid"
            [isChangePlan]="true"
            [selectedPlanId]="currentPlanIndex || 0"
            [currentPlanId]="currentPlanIndex"
            (selectVariation)="onSelectVariation($event)"
            (addToCart)="onAddToCartFromCard($event)"
          >
          </umkt-expansable-card>

          <div class="modal-footer">
            <button
              *ngIf="dismissible"
              type="button"
              class="btn btn-secondary"
              (click)="back()"
            >
              {{ 'pages.planDetails.ChangePlanModal.back' | i18n }}
            </button>

            <button
              type="button"
              class="btn btn-primary"
              [disabled]="!selectedVariation || selectedVariation.uuid === plan?.productUuid"
              (click)="confirmOrder()"
            >
              {{ 'pages.planDetails.ChangePlanModal.confirmChange' | i18n }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>